"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayVault = exports.getVaultWithdrawQueueRedeemableTokenAccountAddress = exports.getWithdrawQueueNodeAddress = exports.getWithdrawQueueHeaderAddress = exports.getDepositQueueNodeAddress = exports.getDepositQueueHeaderAddress = exports.getVaultDepositQueueUnderlyingTokenAccountAddress = exports.getVaultUnderlyingTokenAccountAddress = exports.getVaultAuthorityAddress = exports.getRedeemableMintAddress = exports.getVaultAddress = exports.getStateAddress = exports.VAULT_WITHDRAW_QUEUE_REDEEMABLE_SEED = exports.WITHDRAW_QUEUE_SEED = exports.VAULT_DEPOSIT_QUEUE_UNDERLYING_SEED = exports.DEPOSIT_QUEUE_SEED = exports.USER_REDEEMABLE_SEED = exports.VAULT_AUTHORITY_SEED = exports.VAULT_UNDERLYING_SEED = exports.STATE_SEED = exports.REDEEMABLE_MINT_SEED = void 0;
const vault_1 = require("./vault");
const web3_js_1 = require("@solana/web3.js");
exports.REDEEMABLE_MINT_SEED = "redeemable-mint";
exports.STATE_SEED = "state";
exports.VAULT_UNDERLYING_SEED = "vault-underlying";
exports.VAULT_AUTHORITY_SEED = "vault-authority";
exports.USER_REDEEMABLE_SEED = "user-redeemable";
exports.DEPOSIT_QUEUE_SEED = "deposit-queue";
exports.VAULT_DEPOSIT_QUEUE_UNDERLYING_SEED = "vault-deposit-queue-underlying";
exports.WITHDRAW_QUEUE_SEED = "withdraw-queue";
exports.VAULT_WITHDRAW_QUEUE_REDEEMABLE_SEED = "vault-withdraw-queue-redeemable";
function getStateAddress() {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from("state")], vault_1.vault.programId);
}
exports.getStateAddress = getStateAddress;
function getVaultAddress(vaultName) {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from(vaultName)], vault_1.vault.programId);
}
exports.getVaultAddress = getVaultAddress;
function getRedeemableMintAddress(vault) {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from(exports.REDEEMABLE_MINT_SEED), vault.toBuffer()], vault_1.vault.programId);
}
exports.getRedeemableMintAddress = getRedeemableMintAddress;
function getVaultAuthorityAddress() {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from(exports.VAULT_AUTHORITY_SEED)], vault_1.vault.programId);
}
exports.getVaultAuthorityAddress = getVaultAuthorityAddress;
function getVaultUnderlyingTokenAccountAddress(vault) {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from(exports.VAULT_UNDERLYING_SEED), vault.toBuffer()], vault_1.vault.programId);
}
exports.getVaultUnderlyingTokenAccountAddress = getVaultUnderlyingTokenAccountAddress;
function getVaultDepositQueueUnderlyingTokenAccountAddress(vault) {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from(exports.VAULT_DEPOSIT_QUEUE_UNDERLYING_SEED), vault.toBuffer()], vault_1.vault.programId);
}
exports.getVaultDepositQueueUnderlyingTokenAccountAddress = getVaultDepositQueueUnderlyingTokenAccountAddress;
function getDepositQueueHeaderAddress(vault) {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from(exports.DEPOSIT_QUEUE_SEED), vault.toBuffer()], vault_1.vault.programId);
}
exports.getDepositQueueHeaderAddress = getDepositQueueHeaderAddress;
function getDepositQueueNodeAddress(queueHeader, userKey, seqNum) {
    return web3_js_1.PublicKey.findProgramAddressSync([
        Buffer.from(exports.DEPOSIT_QUEUE_SEED),
        queueHeader.toBuffer(),
        userKey.toBuffer(),
        seqNum.toArrayLike(Buffer, "le", 8),
    ], vault_1.vault.programId);
}
exports.getDepositQueueNodeAddress = getDepositQueueNodeAddress;
function getWithdrawQueueHeaderAddress(vault) {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from(exports.WITHDRAW_QUEUE_SEED), vault.toBuffer()], vault_1.vault.programId);
}
exports.getWithdrawQueueHeaderAddress = getWithdrawQueueHeaderAddress;
function getWithdrawQueueNodeAddress(queueHeader, userKey, seqNum) {
    return web3_js_1.PublicKey.findProgramAddressSync([
        Buffer.from(exports.WITHDRAW_QUEUE_SEED),
        queueHeader.toBuffer(),
        userKey.toBuffer(),
        seqNum.toArrayLike(Buffer, "le", 8),
    ], vault_1.vault.programId);
}
exports.getWithdrawQueueNodeAddress = getWithdrawQueueNodeAddress;
function getVaultWithdrawQueueRedeemableTokenAccountAddress(vault) {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from(exports.VAULT_WITHDRAW_QUEUE_REDEEMABLE_SEED), vault.toBuffer()], vault_1.vault.programId);
}
exports.getVaultWithdrawQueueRedeemableTokenAccountAddress = getVaultWithdrawQueueRedeemableTokenAccountAddress;
function displayVault(vault) {
    console.log(`[DISPLAY_VAULT] Vault: ${vault.vaultName}, EpochTimes: ${JSON.stringify(vault.epochTimes)}, StartEpochVaultBalance: ${vault.startEpochVaultBalance}`);
}
exports.displayVault = displayVault;
